module.exports = __webpack_public_path__ + "static/media/img-update.d7cb02c6.png";